import React, { useState } from 'react';
import './App.css';
import HorasPorProducto from './components/HorasPorProducto';
import LoginPage from './components/LoginPage';
import PWARegistration from './components/PWARegistration';
import InstallPWA from './components/InstallPWA';
import ConnectionStatus from './components/ConnectionStatus';
import MobileUpdate from './components/MobileUpdate';
import MobileDebug from './components/MobileDebug';
import { logoutHorasSession, getSessionUser, SessionUser } from './services/horasService';
import AvatarMenu from './components/AvatarMenu';

function readStoredToken(): string | null {
  try {
    return sessionStorage.getItem('sdp_horas_token');
  } catch {
    return null;
  }
}

function App() {
  const [token, setToken] = useState<string | null>(() => readStoredToken());
  const [sessionUser, setSessionUser] = useState<SessionUser | null>(() => getSessionUser());
  const [vistaActiva, setVistaActiva] = useState<'producto'>('producto');

  if (!token) {
    return (
      <PWARegistration>
        <div className="App">
          <header className="App-header">
            <h1>Neos Contratos SDP - Panel de Control</h1>
          </header>
          <LoginPage onLoggedIn={(t) => { setToken(t); setSessionUser(getSessionUser()); }} />
          <InstallPWA />
        </div>
      </PWARegistration>
    );
  }

  return (
    <PWARegistration>
      <div className="App">
        <ConnectionStatus />
        <MobileUpdate />
        <MobileDebug />
        <header className="App-header">
          {sessionUser && (
            <AvatarMenu
              sessionUser={sessionUser}
              onLogout={() => { logoutHorasSession(); setToken(null); setSessionUser(null); }}
            />
          )}
          <h1>Neos Contratos SDP - Panel de Control</h1>
          <div className="nav-buttons">
            <button
              type="button"
              className={`nav-button ${vistaActiva === 'producto' ? 'activo' : ''}`}
              onClick={() => setVistaActiva('producto')}
            >
              🏭 Por Producto
            </button>
          </div>
        </header>
        <main>
          {vistaActiva === 'producto' ? <HorasPorProducto /> : null}
        </main>
        <InstallPWA />
      </div>
    </PWARegistration>
  );
}

export default App;
